import {
  Component,
  EventEmitter, Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit, OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  @Input() placeholder = 'Search project, site, tag, drawing...';
  @Output() handleSearch: EventEmitter<string> = new EventEmitter();

  form = new FormGroup({
    searchText: new FormControl('')
  });

  constructor(private analyticsService: AnalyticsService) {
    this.form.controls.searchText.valueChanges.pipe(
        debounceTime(1500),
        takeUntil(this.onDestroy)
      )
      .subscribe(data => {
        this.handleSearch.emit(data);
        if (data && data.length >= 3) {
          this.analyticsService.capture('search_performed', {
            query_length: data.length,
          });
        }
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
